module.exports = __webpack_public_path__ + "img/SG.da05216c.svg";